import { Injectable } from '@angular/core';
import { Upload } from 'src/app/uploads/upload';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})

export class UploadService {

  constructor(private storage: AngularFireStorage) { }

  createUpload(upload: Upload, filePath: string){

    const ref = this.storage.ref(`${filePath}/${upload.file.name}`);
    const task = ref.put(upload.file);
    upload.progress = task.percentageChanges();
    
    task.snapshotChanges().pipe(
      finalize(() => {
        upload.name = upload.file.name;
        ref.getDownloadURL().subscribe((url) => {
          upload.url = url; 
        })
      })
    )
    .subscribe();
  }
}

